import { cloudinary } from '@trmediaab/zebra-utils';
import PropTypes from 'prop-types';

import { imagePropType } from '~/utils/prop-types';

// Note - to get sharp images we request them larger than their display size
// TODO: Use picture and srcSet, see src/components/Image in the travronden project
const imgScaleFactor = 2.5;
const maxImgSize = 1600;
const applyScale = size => Math.min(size * imgScaleFactor, maxImgSize);

function Img({
  image,
  width,
  height,
  className,
  alt = '',
  aspectRatio,
  transforms = [],
}) {
  const scaledWidth = applyScale(width);
  const imageId = image.image_id || image.cdn_id;

  if (height != null) {
    transforms.push(`h_${applyScale(height)}`);
  }

  let src = cloudinary.getUrl(imageId, scaledWidth, aspectRatio, transforms);

  // If we dont have an aspectRatio, but we have a focus_point,
  // we need to set the aspectRatio to something for the cropping to work
  if (!aspectRatio && image.focus_point) {
    const transformsWithFocus = cloudinary.getFocusGravity(image.focus_point);
    transformsWithFocus.push(...transforms);
    src = cloudinary.getUrl(imageId, scaledWidth, [16, 9], transformsWithFocus);
  }

  return <img alt={alt} src={src} width={width} className={className} />;
}

Img.propTypes = {
  image: imagePropType.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  alt: PropTypes.string,
  aspectRatio: PropTypes.arrayOf(PropTypes.number),
  transforms: PropTypes.array,
};

export default Img;
